import { MuggleMixin, MagicConfigMixin, InputMode, InputType, MagicEmit } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import InputComponent from '../input/input.vue.js';
import '../input/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const isAndroid = /Android/.test(navigator.appVersion);
let FormFieldComponent = class extends Mixins(MuggleMixin, MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.focused = false;
    this.hadProblem = false;
    this.numeric = false;
  }
  get hasMessage() {
    return !!this.message;
  }
  get hasProblem() {
    return this.hasError || this.hasWarning || this.forceError;
  }
  get shouldDisplayMessage() {
    return (this.hasProblem && (this.hadProblem || !this.focused) || this.forceError) && this.$attrs.disabled === void 0;
  }
  get hasValidationState() {
    return this.hasSuccess || this.hasError || this.hasWarning;
  }
  get attributes() {
    return this.patchInputMode(this.$filteredAttrs);
  }
  get isFakeNumericPassword() {
    return this.$filteredAttrs.inputmode === InputMode.NUMERIC && this.$filteredAttrs.type === InputType.PASSWORD;
  }
  mounted() {
    const { customElement } = this.$root.$options;
    if (!customElement) {
      return;
    }
    customElement.addEventListener("focus", () => {
      const input = this.$refs.input;
      if (!input) {
        return;
      }
      input.focus();
    });
  }
  onBlur() {
    this.hadProblem = this.hasProblem;
    this.focused = false;
    this.$emit("on-focus", false);
  }
  onHasProblemChanged(val) {
    if (!val) {
      this.hadProblem = false;
    } else {
      this.hadProblem = true;
    }
  }
  onFocus({ target }) {
    this.$emit("on-focus", true);
    this.focused = true;
    const focused = target.shadowRoot && target.shadowRoot.activeElement || document.activeElement;
    if (!this.disableAutoscroll && isAndroid && focused) {
      setTimeout(() => {
        const { height, top } = focused.getBoundingClientRect();
        const centerY = window.scrollY + top + height / 2;
        window.scrollTo(0, centerY - window.innerHeight / 2);
      }, 200);
    }
  }
  onInput(event) {
    return this.getCustomEventValue(event);
  }
  onChange(event) {
    return this.getCustomEventValue(event);
  }
  getCustomEventValue(event) {
    const e = event;
    if (e.detail && e.detail[0]) {
      return e.detail[0];
    }
    const target = event.target;
    if (target && target.value) {
      return target.value;
    }
    return null;
  }
  patchInputMode(attr) {
    if (attr.inputmode === InputMode.NUMERIC && attr.type === InputType.PASSWORD) {
      attr.type = InputType.NUMBER;
    }
    return attr;
  }
  applySuggestion() {
    return this.suggestion;
  }
};
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "hasError", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "hasSuccess", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "hasWarning", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "hasInfo", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "forceError", 2);
__decorateClass([
  Prop(String)
], FormFieldComponent.prototype, "message", 2);
__decorateClass([
  Prop(String)
], FormFieldComponent.prototype, "info", 2);
__decorateClass([
  Prop(String)
], FormFieldComponent.prototype, "label", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "noMargin", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "centered", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "consent", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "noIcon", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "disableAutoscroll", 2);
__decorateClass([
  Prop(String)
], FormFieldComponent.prototype, "suggestion", 2);
__decorateClass([
  Prop(String)
], FormFieldComponent.prototype, "suggestionMessage", 2);
__decorateClass([
  Prop(Boolean)
], FormFieldComponent.prototype, "hasSuggestion", 2);
__decorateClass([
  Watch("hasProblem")
], FormFieldComponent.prototype, "onHasProblemChanged", 1);
__decorateClass([
  MagicEmit("input")
], FormFieldComponent.prototype, "onInput", 1);
__decorateClass([
  MagicEmit("change")
], FormFieldComponent.prototype, "onChange", 1);
__decorateClass([
  Emit("apply-suggestion")
], FormFieldComponent.prototype, "applySuggestion", 1);
FormFieldComponent = __decorateClass([
  Component({
    name: "ui-form-field",
    inheritAttrs: false,
    components: {
      "ui-input": InputComponent
    }
  })
], FormFieldComponent);

export default FormFieldComponent;
